// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Luxon = require("luxon");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function from(days, hours, milliseconds, minutes, months, seconds, weeks, years, param) {
  var tmp = {};
  if (years !== undefined) {
    tmp.years = Caml_option.valFromOption(years);
  }
  if (months !== undefined) {
    tmp.months = Caml_option.valFromOption(months);
  }
  if (weeks !== undefined) {
    tmp.weeks = Caml_option.valFromOption(weeks);
  }
  if (days !== undefined) {
    tmp.days = Caml_option.valFromOption(days);
  }
  if (hours !== undefined) {
    tmp.hours = Caml_option.valFromOption(hours);
  }
  if (minutes !== undefined) {
    tmp.minutes = Caml_option.valFromOption(minutes);
  }
  if (seconds !== undefined) {
    tmp.seconds = Caml_option.valFromOption(seconds);
  }
  if (milliseconds !== undefined) {
    tmp.milliseconds = Caml_option.valFromOption(milliseconds);
  }
  return Luxon.Duration.fromObject(tmp);
}

exports.from = from;
/* luxon Not a pure module */
